export default {
  hsk_left_time: "Temps restant pour l'examen",
  hsk_submit_paper: 'Soumettre la copie',
  hsk_not_finished: '未完成',
  hsk_not_start: '未开始',
  hsk_finished: 'Terminé',
  hsk_if_test: "Vous n'avez pas terminé votre dernier examen. Continuer ?",
  hsk_start_again: 'Redémarrer',
  hsk_go_on: "Continuer l'examen",
  hsk_if_save:
    'Quitter ? Vos réponses seront enregistrées pour que vous puissiez continuer la prochaine fois.',
  hsk_login_filed: '您的登录信息已失效，我们将不会保留您的答题记录',
  hsk_report: 'Résultats',
  hsk_point: 'points',
  hsk_qualified_point: 'Note de passage : {points}',
  hsk_part1: 'Partie {part}',
  hsk_accuracy1: 'Correct',
  hsk_test_again: 'Testez à nouveau',
  hsk_example: 'Ex.',
  hsk_example_eg: 'Ex.',
  hsk_answer_analysis: '答案解析：',
  hsk_your_answer: '你的答案：',
  hsk_audio_text: '听力原文：',
  hsk_correct_answer: '正确答案：',
  hsk_listen_name: 'Compréhension orale',
  hskk_listen_name: "Test des haut-parleurs et du microphone",
  hsk_read_name: 'Lecture',
  hsk_write_name: 'Expression écrite',
  hsk_reference_answer: 'Exemple:',
  hsk_reference_answer_hskk: 'Contenu audio des questions:',
  hsk_submit_msg: 'Soumettre les réponses',
  hsk_homework_no_answer: 'Non répondu',
  hsk_practice_sava: '确认退出练习吗？退出后当前作答不保留。',
  hsk_practice_go: '去练习',
  hsk_practice_part: '练习模块',
  hsk_practice_operate: '操作',
  hsk_practice_check: 'Voir',
  hsk_practice_num1: 'Correct',
  hsk_practice_num2: 'sur {totalNum} questions au total',
  hsk_preview_listen_msg:
    "Pendant la diffusion de l'enregistrement d'introduction, vous pouvez prévisualiser les questions de la section d'écoute.",
  hsk_preview_listen_prompt:
    "Pendant la lecture de l'audio d'introduction, vous pouvez prévisualiser les questions dans la section d'écoute. Veuillez ne pas rafraîchir ou fermer la page pendant le test, sinon les données des réponses seront perdues.",
  hsk_enter_next_segment_msg: 'Passer à la section suivante ?',
  hsk_enter_next_segment_preview:
    "Voulez-vous terminer l'aperçu maintenant ? Lorsque le temps d'aperçu est écoulé, votre test d'écoute commencera.",
  hsk_enter_next_segment_listen_tip: "Vous avez {count} questions d'écoute à répondre.",
  hsk_enter_next_segment_listen:
    "Voulez-vous commencer la révision de vos réponses aux questions dans la section d'écoute ?",
  hsk_enter_next_segment_listen_review_start:
    "Vous avez maintenant {count} minutes pour réviser vos réponses aux questions dans la section d'écoute.",
  hsk_enter_next_segment_listen_review:
    "Êtes-vous sûr de vouloir terminer votre révision ? Une fois que vous aurez terminé votre révision, la section d'écoute prendra fin et vous ne pourrez plus y revenir.",
  hsk_enter_next_segment_read_tip: 'Vous avez maintenant {count} questions de lecture à répondre.',
  hsk_enter_next_segment_read:
    'Êtes-vous sûr de vouloir soumettre vos réponses aux questions dans la section de lecture ? Une fois soumises, la section de lecture prendra fin et vous ne pourrez plus y revenir.',
  hsk_enter_next_segment_write_tip: "Vous avez maintenant {count} questions d'écriture à répondre.",
  hsk_enter_next_segment_write: 'Soumettre votre papier ?',
  hsk_end_preview: "Fin de l'aperçu",
  hsk_submit_listen: 'Soumettre les réponses de la section de compréhension orale',
  hsk_end_review: 'Fin de la révision',
  hsk_start_exam: "Commencer l'examen",
  hsk_link_test: 'Vrais examens passés',
  hsk_link_tips: 'Faites un vrai examen passé et obtenez un certificat officiel',
  hsk_buy: 'Acheter',
  hsk_test_ready: "Préparation avant l'examen",
  hsk_test_ready_tips:
    "Cet examen comprend des exercices d'écoute et de compréhension. Veuillez ajuster vos paramètres audio si nécessaire pour vous assurer d'entendre clairement la musique en cours de lecture.",
  hsk_test_content: 'Contenu',
  hsk_test_num: 'Nb. de questions',
  hsk_total_num: 'Nb. total de questions',
  hsk_test_time: "Durée de l'examen",
  hsk_time_total: 'Temps total',
  hsk_test_minute: 'min.',
  hsk_about: 'À propos de',
  hsk_abbreviation: 'Abréger',
  hsk_determine_ans: 'Êtes-vous sûr de vouloir commencer ?',
  hsk_determine_ans_tips:
    'Une fois que vous avez commencé votre réponse, vous ne pouvez plus voir le texte original.',
  no_data: 'Pas de données',
  hsk_question_number: 'No. de questions',
  hsk_test_rate: "% de l'examen",
  hsk_right_rate: 'Correct',
  hsk_operation: 'Actions',
  hsk_skip: 'Passer',
  hsk_spend: 'Dépenser',
  hsk_cost: 'Coût',
  hsk_credit: 'Crédit',
  hsk_pay_successfully: 'Paiement réussi',
  hsk_select_amount: 'Sélectionnez le montant de recharge',
  button_common_ok: 'Confirmer',
  button_common_cancel: 'Annuler',
  change_lang_ok: 'Confirmer',
  change_lang_cancel: 'Annuler',
  hint_player_loader_error: 'Échec de la lecture audio',
  hint_common_wait_loading: 'Téléchargement des ressources en cours...',
  button_common_hand_in: 'Soumettre',
  test_total_question: '{count} questions au total',
  test_release: 'Publier',
  test_off_shelf: 'Annuler la publication',
  test_enable: 'Publier',
  test_record: 'Enregistrement des examens simulés terminés',
  test_finish_time: 'Terminé',
  test_paper: "Copie d'examen",
  test_confirm_use: "Publier l'examen simulé",
  test_confirm_off_shelf: "Annuler la publication de l'examen simulé",
  test_has_on_shelf: 'Disponible',
  test_un_release: 'Non publié',
  test_un_enable: 'Indisponible',
  test_max_score: 'Meilleur score',
  test_average_score: 'Score moyen',
  test_min_score: 'Score le plus bas',
  test_all: 'Tous',
  test_has_practiced: 'Exercices terminés, afficher les résultats',
  test_paper_office: 'Examen plus disponible',
  test_complete_introduce: 'Description complète',
  test_course_link: 'Cours officiels',
  test_about_down_load: 'Téléchargements',
  test_pay: 'Payer',
  mark_answer_user: 'Soumetteur',
  mark_answer_time: 'Heure de soumission',
  mark_correct_time: "Temps d'évaluation",
  mark_correct_status: 'Statut',
  mark_correct_user: 'Évaluateur',
  mark_correct_option: 'Actions',
  mark_correct_ing: 'Évaluation en cours',
  mark_un_correct: 'Non évalué',
  mark_has_correct: 'Évalué',
  mark_report_tips:
    "Remarque : La partie écriture n'a pas encore été incluse dans le score total. Les questions 99-100 seront évaluées par un examinateur professionnel dans les 48 heures. Votre score sera immédiatement mis à jour ici et nous vous en informerons par email.",
  mark_report_tips_hskk:
    "Remarque: les questions d'examen seront corrigées par un évaluateur professionnel dans les 48 heures, le chapitre général sera mis à jour en même temps après la correction, nous vous en informerons par courrier électronique",
  mark_submit_btn: 'Soumettre',
  mark_submit_tips: 'Soumettre vos réponses ?',
  mark_back: 'Retour',
  mark_correct_tips: "L'examen simulé en cours d'évaluation ne peut pas être modifié.",
  mark_correct_person: 'Évaluation manuelle',
  search_user_message: 'Rechercher un utilisateur',
  mark_current_user: 'Utilisateur actuel',
  mark_correct_paper: 'Évaluer',
  mark_all_status: 'Tous les statuts',
  mark_all_level: 'Tous les niveaux',
  mark_overtime: 'En retard',
  mark_answer: 'Répondre',
  home_test_registration: "S'inscrire",
  home_word_outline: 'Programme',
  home_online_practice: 'Échantillon',
  home_test: 'Examens',
  home_page: 'Accueil',
  common_text_control_speed: 'Vitesse',
  button_common_playback: "Lire l'enregistrement",
  common_text_file_error: 'Échec du téléchargement des ressources. Veuillez réessayer.',
  common_text_server_error: 'Réessayez une fois',
  common_text_none_network: 'Réseau instable',
  button_common_start_over: 'Réessayer',
  evaluating_tips_common:
    'Il y a une grande différence entre votre enregistrement et le texte. Veuillez réessayer.',
  evaluate_common_total_score: 'Score',
  evaluate_common_training_remain: 'Restant :',
  evaluate_common_training_readyRcord: 'Préparez-vous à enregistrer',
  evaluate_common_training_atleast: "L'enregistrement doit durer plus de 1 sec.",
  evaluate_common_training_atleast2: "L'enregistrement doit durer plus de 2 secs.",
  evaluate_common_training_evaluting: 'Évaluation',
  evaluating_tips_additionalAndBack: 'Lire à nouveau',
  textbook_chioce_word_text_correct_tip: 'Bonne réponse. Super !',
  textbook_chioce_word_text_error_tip: 'Mauvaise réponse. Continuez !',
  textbook_reading_comprehension_stem: 'Lecture',
  spc_back_tips: 'Quitter ? Vos réponses ne seront pas enregistrées.',
  spc_level_text: 'Test de niveau',
  spc_capability_assessment: 'Évaluation des compétences',
  spc_pick_level: 'Choisir le niveau',
  spc_listen: 'Écoute',
  spc_speak: 'Expression orale',
  spc_read: 'Lecture',
  spc_write: 'Écriture',
  spc_translation: 'Traduction',
  spc_result_tips:
    "D'après votre test de niveau, il semble que vous travailliez vers le HSK {level}.",
  spc_recommend_test: '推荐备考 HSK {level} 级',
  spc_recommend_test1: 'Vous travaillez vers <strong> HSK {level}</strong>.',
  spc_again_test: 'Tester à nouveau',
  spc_where_tips: 'Pas sûr de votre niveau ?',
  spc_immediate_test: 'Passez un test',
  spc_test_content: "Contenu de l'examen",
  spc_test_content_desc:
    "Une série de questions dynamiquement sélectionnées qui testent différentes compétences à différents niveaux. Les questions évaluent vos capacités d'écoute, de lecture, de parole (lecture à haute voix), d'écriture (saisie ou sélection de caractères) et de traduction.",
  spc_test_timer: 'Temps',
  spc_test_timer_desc:
    'Le test dure environ 15 minutes - généralement moins si vous êtes à un niveau inférieur et parfois un peu plus longtemps si vous êtes à un niveau supérieur.',
  spc_test_result: 'Résultats',
  spc_test_result_desc:
    'Le test vous aide à déterminer rapidement vers quel niveau HSK vous travaillez et quelles compétences vous devez le plus travailler.',
  vocab_level_word: 'Liste de vocabulaire HSK {level}',
  vocab_total_item: '{total} éléments au total',
  vocab_search: 'Rechercher le niveau',
  vocab_all_marked: 'Tous',
  vocab_already_marked: 'Marqué',
  vocab_unmarked: 'Non marqué',
  vocabulary: 'Caractères',
  vocab_pinyin: 'Pinyin',
  vocab_translate: 'Traduction',
  vocab_mark: 'Marquer',
  delete_confirmation: "Supprimer l'élément de vocabulaire ?",
  cancel: 'Annuler',
  del: 'Supprimer',
  edit_vocab: 'Modifier le vocabulaire',
  save: 'Enregistrer',
  add_vocab: 'Ajouter du vocabulaire',
  hanzi: 'Chinois',
  num_bihua: 'Traits',
  write_demo: 'Animation',
  vocab_side: 'Composants',
  level: 'Niveaux',
  see_more: 'Voir plus',
  same_read_word: 'Sons identiques',
  samilar_read_word: 'Sons similaires',
  add_mark: 'Marque-page',
  word_team: 'Mots',
  instance: "Phrases d'exemple",
  include_num_char: 'Comprend {total} caractères',
  length_diff: 'Les nombres de syllabes en Pinyin et de caractères chinois ne correspondent pas',
  add_word_success: 'Vocabulaire ajouté avec succès',
  add_word_fail: "Échec de l'ajout du vocabulaire",
  edit_word_success: 'Vocabulaire modifié avec succès',
  edit_word_fail: 'Échec de la modification',
  del_success: 'Supprimé',
  del_fail: 'Échec de la suppression',
  mark_free: 'Marqué librement, par exemple marqué comme "maîtrisé"',
  write_word_sentence: 'Veuillez faire une phrase basée sur les mots ci-dessus…',
  write_word_artical: 'Veuillez écrire un court essai basé sur les mots-clés ci-dessus…',
  write_img_artical: "Veuillez écrire un court essai basé sur l'image ci-dessus…",
  write_artical_title: 'Veuillez entrer votre titre…',
  write_artical_content: 'Veuillez saisir votre contenu…',
  my_wallet: 'Mes achats',
  learn_history: "Historique d'apprentissage",
  manage: 'Rechercher des utilisateurs',
  birthday: 'Date de naissance',
  email: 'E-mail',
  change_pw: 'Modifier le mot de passe',
  edit_info: 'Modifier les détails',
  lastName: 'Nom de famille',
  firstName: 'Prénom',
  gender: 'Sexe',
  female: 'Féminin',
  male: 'Masculin',
  non_disclosure: 'Ne pas divulguer',
  change_avatar: "Changer d'avatar",
  preview_avatar: 'Aperçu',
  upload_image: 'Télécharger une image',
  change_image: "Changer l'image",
  enter_old_pw: 'Ancien mot de passe',
  enter_new_pw: 'Nouveau mot de passe',
  enter_new_pw_again: 'Saisissez à nouveau votre nouveau mot de passe',
  forget_pw: 'Mot de passe oublié',
  recharge: 'Recharger',
  left_balance: 'Crédit disponible',
  consume_log: 'Examens',
  recharge_log: 'Historique des achats',
  consume_time: 'Date/Heure',
  consume_source: 'Crédits dépensés sur',
  consume_money: 'Crédits',
  total_item_log: '{total} enregistrements au total',
  recharge_time: 'Date/heure',
  recharge_num: 'Crédits',
  recharge_money: 'Montant',
  recharge_method: 'Méthode',
  learn_content: 'Examen simulé',
  total_score: 'total',
  view_result: 'Voir les résultats',
  management: '用户管理',
  give_history: '赠送历史',
  total_recharge: '总计充值',
  last_login: '最后登录',
  give: '赠送',
  gifted: 'Offert',
  give_time: 'Date/Heure',
  give_to_person: '授予人',
  opera_person: 'Fourni par',
  give_to: '赠送给',
  old_password_empty: "Le champ de l'ancien mot de passe ne peut pas être laissé vide",
  diff_password: 'Les mots de passe saisis ne correspondent pas',
  change_pw_success: 'Le mot de passe a été mis à jour',
  change_pw_fail: 'Échec de la modification du mot de passe',
  change_info_success: 'Informations mises à jour avec succès',
  change_info_fail: 'Échec de la mise à jour des informations',
  statistics_center: 'Voir les statistiques',
  select_recharge_mount: 'Sélectionner le montant à recharger',
  waiting_pay: 'En attente de paiement',
  has_no_resolve_credit: "Le paiement n'a pas été reçu. Veuillez essayer à nouveau.",
  complete_pay: 'Paiement terminé',
  pay_fail: 'Échec du paiement',
  give_success: 'Crédits donnés avec succès',
  give_fail: "Échec de l'attribution des crédits",
  change_avatar_success: 'Avatar mis à jour avec succès',
  change_avatar_fail: "Échec de la mise à jour de l'avatar",
  enter_family_name: 'Nom de famille',
  enter_given_name: 'Prénom',
  log_in: '登录',
  log_in_error: '登录失败',
  email_address: 'Adresse e-mail',
  invalid_email_address: "Format d'email invalide",
  password: 'Mot de passe',
  password_tip: 'Le mot de passe doit comporter entre 6 et 20 caractères',
  invalid_password: 'Format de mot de passe incorrect',
  have_account: 'Vous avez déjà un compte {text}',
  sign_up: '注册',
  sign_up_error: '注册失败',
  forget_pw_success: 'Email de réinitialisation du mot de passe envoyé avec succès',
  forget_pw_error: "Échec de l'envoi de l'email de réinitialisation du mot de passe",
  loading: 'Chargement',
  account_block: 'Ce compte est désactivé',
  account_block_tip:
    "Veuillez contacter un agent de votre école ou organisation pour plus d'informations",
  resend_email: "Renvoyer  l'e-mail",
  resend_email_success: 'Email renvoyé avec succès',
  resend_email_error: "Échec de la renvoi de l'email",
  i_am: '我是',
  choose_role: 'Lequel vous décrit le mieux',
  choose_role_error: 'Rôle sélectionné incorrect',
  continue: "Continuer l'examen",
  learner: 'Apprenant',
  learner_description: "J'apprends le chinois",
  teacher: 'Enseigant',
  teacher_description: "J'enseigne le chinois",
  setup_account_error: 'Échec de la configuration du compte',
  tos_link: 'Conditions de service',
  privacy_link: 'Politique de confidentialité',
  email_verified: 'E-mail vérifié',
  email_verified_tip: "Merci d'avoir vérifié votre adresse e-mail.",
  email_verified_error: 'Échec de la vérification de votre compte',
  something_wrong: "Quelque chose s'est mal passé",
  retry: 'Réessayer',
  guardian_consent_error: 'Échec du consentement',
  about_us: 'À propos de nous',
  about_us_new: 'À propos de nous',
  feedback: 'Contactez-nous !',
  download: 'Télécharger',
  submit: 'Envoyer',
  feedback_success: 'Envoyé avec succès',
  feedback_error: "Échec de l'envoi",
  logout: 'Déconnexion',
  my_account: 'Mon compte',
  login_signup: "Se connecter / S'enregistrer",
  please_enter_content: 'Veuillez entrer votre commentaire (obligatoire)',
  describe_detail: 'Si vous trouvez une erreur, veuillez fournir autant de détails que possible.',
  upload_picture:
    "Téléchargez jusqu'à {maxFiles} images jpg/png (facultatif), max. 2 MB par image.",
  file_error: 'Le fichier est au mauvais format ou est trop volumineux',
  file_num_limit: 'Nombre maximal de téléversements : {maxFiles} fichiers',
  sure_change_lang: 'Confirmer le changement de langue',
  privacy_policy_text1: 'HSK Mock.com——汉考国际唯一认证的模拟考试平台',
  privacy_policy_text2:
    '模拟考试平台由Wo Hui和汉考国际基于HSK和YCT试题库合作开发和运营。提供完整真题模考训练，为中文学习者的标准化中文考试保驾护航。',
  privacy_policy_text3: 'Wo Hui Mandarin是汉考国际官方合作伙伴。 ',
  privacy_policy_text4:
    '汉考国际教育科技（北京）有限公司，是专业化国际中文教育考试服务机构，致力于为世界各国（地区）提供国际中文教育和考试研究设计、技术研发、考试实施、市场推广等方面的专业化服务，最大限度满足全球中文学习者和中文教育机构的需求。',
  privacy_policy_text5:
    '我会是由EiM国际教育集团于2018年在新加坡创立的，致力于为全球的中文学习者提供学习中文的技术支持、平台服务的独立公司。为不同的学生提供多样的课程；为教师提供海量教学资源与实用教学工具。科技智能辅助教学，解放教师双手，完善教学过程，帮助学生实现自己的个性化目标，鼓励学生成为卓越的独立学习者。 ',
  privacy_policy_text6:
    '汉考国际与我会具有良好的合作基础，共同致力于中文学习的推广与发展。为更精准的判断学生的水平，进行针对性学习，模拟真实考试环境，两者进行深度的战略合作，全方位满足中文学习者的学习需求。',
  level_test: 'Test de niveau',
  level_test_example:
    "Si vous n'êtes pas sûr de votre niveau, passez un test court et gratuit pour découvrir le niveau d'examen vers lequel vous devez travailler.",
  download_app_mobile:
    "Pour utiliser HSK Mock, veuillez visiter hskmock.com sur un ordinateur de bureau ou télécharger l'application mobile.",
  common_video_failed: 'Échec du chargement audio',
  member_error: "Quelque chose s'est mal passé avec la ressource !",
  agree_policy:
    '我已阅读并同意<u class="strong"><a href="{url}" target="_blank">《用户协议》</a></u>和<u class="strong"><a href="{userUrl}" target="_blank">《隐私政策》</a></u>',
  please_check: '请勾选阅读并同意《用户协议》和《隐私政策》',
  media_devices_unsupported_browserLabel:
    'Google Chrome est recommandé comme navigateur par défaut. Méthode de configuration (en prenant Windows 10 comme exemple) : Paramètres-Application-Application par défaut-Navigateur Web-sélectionner Google Chrome',
  media_devices_help_title: 'Activer ou non le microphone',
  media_devices_help_content:
    "Vous avez besoin d'autorisation pour accéder au microphone afin d'enregistrer l'audio",
  batch_exist_user: '{number} 已注册用户',
  batch_and: '和',
  batch_un_exist_user: '{number} 未注册用户',
  batch_from: 'De',
  batch_notes: '备注',
  batch_something: '请填写',
  batch_people_number: '赠送人数量',
  batch_use_number2: '消耗量',
  batch_operation_status: '操作状态',
  batch_ing_status: '进行中',
  batch_success: '成功',
  batch_failed: '失败',
  batch_select: 'Sélectionner',
  common_to: 'à',
  common_start_time: 'Démarrer',
  common_end_time: 'Fin',
  batch_search_tips: '在此处粘贴用户帐号（请用逗号分隔，一次最多可以导入 50 个用户）',
  common_un_exist: '未注册',
  common_invalid: '无效',
  batch_all_give: '批量赠送试卷',
  batch_single_people: '个人',
  batch_all: '批量',
  batch_name: 'Nom',
  batch_added_credits: '赠送数量',
  batch_spent_credits: '花费数量',
  batch_account_status: '账号状态',
  batch_Added_total: '总计赠送',
  batch_spent_total: '总计花费',
  batch_Remaining: '剩余',
  batch_Recipients: '授予人',
  batch_Active: '已激活',
  batch_search: 'Rechercher le niveau',
  certificate_details: 'Détails du certificat',
  get_official_mock_certificate: 'Obtenir le certificat officiel de simulation',
  certificate_tips: 'Si nécessaire, vous pouvez éditer les détails du certificat.',
  country: 'Nationalité',
  select_country: 'Veuillez sélectionner votre nationalité',
  email_to: 'Le certificat sera envoyé par e-mail à :',
  polyphonic: 'Mot de plusieurs sons',
  click_tips: 'Cliquez sur le numéro de la question pour voir la réponse',
  download_tips: 'Vous pouvez télécharger un certificat pour tout test simulé que vous réussissez',
  cancel_delete_account: 'Supprimer mon compte',
  cancel_confirm: 'Confirmer',
  user_apply_delete_account_title: 'Demande de suppression de compte',
  user_apply_delete_account_confirm_tip: 'Confirmez vos détails de connexion',
  user_apply_delete_account_alwaysTip:
    'Vous demandez la suppression permanente de votre compte Mock HSK et des données personnelles associées dès maintenant.',
  user_apply_delete_account_confirm_tip2:
    'Pour soumettre cette demande, veuillez confirmer votre identité.',
  user_apply_delete_account_desc:
    'Votre compte {email} est utilisé pour vous connecter aux applications <a href="{wohuiLink}" target="_blank">Wo Hui Mandarin</a> et <a href="{mockLink}" target="_blank">HSK Mock</a>',
  user_apply_delete_account_desc2:
    'Après suppression, vous ne pourrez plus utiliser ce compte pour vous connecter aux applications ci-dessus.',
  user_apply_delete_account_wohui_title: "Annuler l'abonnement Wo Hui",
  user_apply_delete_account_hsk_title: 'CRÉDITS HSK MOCK',
  user_apply_delete_account_next_tip:
    "En cliquant sur le bouton 'Suivant', vous confirmez avoir lu et accepté ce qui précède.",
  user_apply_delete_account_next_title: 'Suivant',
  user_apply_delete_account_confirm_tip11:
    "Veuillez d'abord annuler votre abonnement, puis revenir pour finaliser votre demande de suppression de compte.",
  cancel_delete_ok: "D'accord",
  cancel_delete_request_send: 'Demande envoyée',
  user_apply_delete_account_confirm_tip8:
    'Votre compte sera définitivement supprimé lorsque votre abonnement expirera le {date}',
  user_apply_delete_account_confirm_tip4: 'Nous enverrons un e-mail à',
  user_apply_delete_account_confirm_tip5: 'pour confirmer que votre compte a été supprimé.',
  user_apply_delete_account_confirm_tip6:
    'Pour annuler votre demande de suppression de compte, cliquez sur “Annuler”',
  user_apply_delete_data_always:
    'Souhaitez-vous annuler votre demande de suppression permanente de votre compte Wo Hui Mandarin et des données personnelles associées ?',
  cancel_delete_yes: 'Oui',
  cancel_delete_no: 'Non',
  user_cancel_delete_success:
    'Nous avons annulé votre demande et ne supprimerons pas votre compte HSK Mock.',
  user_cancel_subscribe_again:
    'Vous devrez vous réabonner à tout abonnement que vous avez précédemment annulé.',
  user_apply_delete_account_confirm_tip9: 'Votre abonnement expire le',
  user_apply_delete_account_confirm_tip10: 'Quand souhaitez-vous supprimer votre compte ?',
  user_apply_delete_account_ok_btn_title: 'Lorsque votre abonnement expire',
  user_apply_delete_account_now_btn_title: 'Maintenant',
  cancel_out_subscription_abnormal: "Les informations d'abonnement sont anormales",
  user_apply_delete_account_confirm_tip3:
    'Vous avez un abonnement facturé automatiquement par Apple. Veuillez annuler votre abonnement avec Apple avant de continuer.',
  user_apply_delete_stripe_tip:
    'Vous avez un abonnement facturé automatiquement sur votre carte de crédit/débit par Stripe. Veuillez vous rendre sur notre site Web',
  user_apply_delete_account_balance: 'Solde du compte',
  user_apply_delete_account_balance_tip:
    'Une fois votre compte supprimé, ces crédits seront perdus pour toujours.',
  user_apply_delete_account_expire:
    'Votre compte sera définitivement supprimé dans les trois jours',
  my_class_name: 'Ma classe',
  my_class_search: 'Rechercher une classe',
  my_class_total: 'total',
  my_class_people: 'Personnes',
  my_class_ci: 'Fois',
  my_class_number: 'Nombre de personnes',
  my_class_ci_number: 'Nombre de fois',
  my_class_tips: 'Cercle intérieur : distribution des examens YCT et HSK.',
  my_class_tips1: 'Cercle extérieur : distribution des niveaux.',
  my_class_all_class: 'Toutes les classes',
  follow_lesson: 'Suivre un cours',
  real_paper: 'Faire un vrai examen',
  start_answer: 'Démarrer',
  edit_message_date: 'Date',
  edit_message_language: 'Langue',
  edit_message_zh: 'Chinois',
  edit_message_en: 'Anglais',
  edit_message_title: 'Titre',
  edit_message_content: 'Veuillez entrer du texte',
  edit_message_show: 'Afficher sur',
  edit_message_save_success: 'Enregistré avec succès',
  edit_message_create_success: 'Ajouté avec succès !',
  edit_message_edit1: 'Modifier',
  edit_message_follow_notice: 'Gérer les notifications',
  edit_message_textarea_tips: 'Inclure un espace après chaque lien',
  edit_message_notifications: 'Gérer les notifications',
  edit_message_Send_time: "Heure d'envoi",
  edit_message_edit_notification: 'Modifier la notification',
  edit_message_add: '+ Ajouter',
  edit_message_from: 'De',
  edit_message_to: 'À',
  edit_message_new_add: 'Ajouter une notification',
  currency: 'Devise',
  pay_failed: "La page de paiement ne s'est pas chargée ?",
  pay_un_finished: 'Impossible de finaliser le paiement ?',
  select_currency_tips:
    'Si vous le souhaitez, vous pouvez sélectionner une devise différente dans le menu déroulant ci-dessous.',
  change_currency_tips:
    'Vous pouvez changer votre devise préférée à tout moment dans "Mon compte".',
  my_homework: 'Mes devoirs',
  my_homework_add: 'Envoyer le devoir',
  my_homework_all_classes: 'Toutes les classes',
  my_homework_paper: "Copie d'examen",
  my_homework_sent_to: 'Envoyé à',
  my_homework_sent_on: 'Commencer après',
  my_homework_due_on: 'À rendre avant',
  my_homework_submitted_assignees: 'Soumis/Attributions',
  my_homework_class_hint:
    "signifie que le devoir n'a été attribué qu'à certains des apprenants de la classe.",
  my_homework_delay_hint: "signifie que l'examen peut toujours être terminé après la date limite.",
  my_homework_add_send_assignment: 'Mettre à jour le devoir',
  my_homework_add_new_assignment: 'Nouveau devoir',
  my_homework_edit_assignment: "Modifier l'attribution",
  my_homework_add_assignment: 'Ajouter une tâche',
  my_homework_add_assignment_details: "1. Détails de l'assignation",
  my_homework_add_issue_time: 'Envoyer',
  my_homework_add_whether_submit: "Autoriser la soumission après la date et l'heure de fin ?",
  my_homework_add_note: 'Remarque',
  my_homework_add_assignees: '2. Bénéficiaires',
  my_homework_edit_add_assignees: '发送对象',
  my_homework_add_group: 'Sélectionner la classe',
  my_homework_add_immediate_release: 'Maintenant',
  my_homework_add_time_release: 'Plus tard',
  my_homework_add_are: 'Oui',
  my_homework_add_no: 'Non',
  my_homework_detail_back: 'Retour à Mes devoirs',
  my_homework_detail_sent_to: 'Envoyé à',
  my_homework_detail_leamers_in: 'apprenants dans',
  my_homework_detail_on: 'le',
  my_homework_detail_to_complete_by: 'à compléter avant',
  my_homework_detail_add_assignee: 'Ajouter un bénéficiaire',
  my_homework_detail_assignee: 'Bénéficiaires',
  my_homework_search_placeholder: 'Veuillez entrer le contenu de recherche',
  my_homework_stu_sent_by: 'Expéditeur',
  my_homework_total_topic_count: '{count} questions au total',
  my_homework_time_full: '{min} min',
  my_homework_select_date_time: "Sélectionner la date et l'heure",
  my_homework_delete_assignment_title: "Supprimer l'assignation",
  my_homework_delete_assignment_tips:
    'Êtes-vous sûr de vouloir supprimer cette assignation ? Cette action est irréversible !',
  my_homework_assignment_add_fail: 'Échec de la publication !',
  my_homework_assignment_add_success: 'Assignation envoyée !',
  my_homework_assignment_edit_success: 'Modifié avec succès !',
  my_homework_assignment_edit_fail: "Échec de l'édition !",
  my_homework_assignment_delete_fail: 'Échec de la suppression !',
  my_homework_assignment_delete_success: 'Supprimé avec succès !',
  my_homework_assignment_due_on: 'À rendre pour le',
  my_homework_assignment_product: 'Produit',
  my_homework_assignment_certificate: 'Certificat',
  my_homework_assignment_reset: 'Réinitialiser',
  my_homework_assignment_reset_title: 'Réinitialiser la section ?',
  my_homework_assignment_gifted: 'Total offert',
  my_homework_assignment_papers: 'papiers',
  my_homework_assignment_send_to: 'Cet exercice a été envoyé à',
  my_homework_assignment_close_tip:
    "L'assignation actuelle n'a pas été enregistrée. Êtes-vous sûr de vouloir quitter ?",
  pay_callback_tips:
    'Si vous êtes en Chine continentale, nous vous recommandons de vous connecter sur le site hskmock.cn, qui prend en charge les paiements par WeChat et Alipay.',
  no_available_class: 'Aucune classe',
  payment_method: 'Mode de paiement',
  wechat_pay: 'WeChat Pay',
  alipay_payment: 'Paiement Alipay',
  card_payment: 'Payer par carte',
  card_payment_description: 'Cartes bancaires étrangères uniquement',
  payment_to_wohui: 'Paiement à Wohui Technology (Shanghai) Co., Ltd.',
  order_submitted:
    'Commande soumise avec succès, veuillez effectuer le paiement dès que possible !',
  order_number: 'Numéro de commande :',
  code_expires:
    'Il reste <span style="color: #fc5a5a;font-size: 16px;font-weight: 500;">{time}</span> secondes avant l\'expiration du code QR.',
  use_weChat: 'Veuillez utiliser WeChat pour scanner et effectuer le paiement via le code QR.',
  code_expired: "Le code QR n'est plus valide",
  amount_payable: 'Montant à payer :',
  use_code: 'Utiliser le code',
  tests: 'Historique des examens',
  level_title: 'Quel est votre niveau cible ?',
  // level_des: "Si vous n'êtes pas sûr(e), vous pouvez participer à un auto-test de niveau gratuit",
  level_des: "Si vous n’êtes pas sûr, Cliquez ici pour <b style=\"color: #000;cursor: pointer;font-weight: 700;\" class=\"clickable\">un test de niveau gratuit ></b>",
  level_HSK_text1:
    "<b>HSK</b> est l'acronyme en pinyin de 'Hanyu Shuiping Kaoshi', ce qui signifie test de compétences en chinois.",
  level_HSK_text2: "C'est le test de compétences en chinois le plus populaire au monde",
  level_YCT_text1: "<b>YCT</b> est l'abréviation de Youth Chinese Tests, ",
  level_YCT_text2:
    "signifiqant l'examen de compétence en chinois pour les élèves du primaire et du secondaire",
  level_BEGINNER: 'Débutant',
  level_INTERMEDIATE: 'Intermédiaire',
  level_ADVANCED: 'Avancé',
  level_dialog_title: 'Test de niveau',
  level_dialog_content:
    'Le test de niveau gratuit prend environ 15 minutes. Les résultats du test afficheront votre niveau actuel du HSK ainsi que votre niveau dans les quatre compétences linguistiques (écoute, lecture, écriture, expression orale)',
  level_dialog_login: 'Connexion / Inscription',
  level_dialog_start: 'Commencer le test de niveau',
  about_us_first_paragraph:
    "HSK Mock est la seule plateforme officielle de simulation d'examen pour les examens de compétences en chinois HSK et YCT, les examens les plus populaires au monde. Cette plateforme est le fruit de la collaboration entre Chinese Testing International et Wohui Mandarin.",
  about_us_second_paragraph:
    "<b>Chinese Testing International</b> (CTI) est le comité d'examen du HSK et du YCT. C'est une société à responsabilité limitée basée à Pékin, qui promeut et soutient l'apprentissage, l'enseignement et les tests de chinois en tant que langue étrangère dans le monde entier en fournissant une gamme de services aux particuliers et aux institutions.",
  about_us_third_paragraph:
    "<b>Wo Hui Mandarin</b> (Wo Hui) est la plateforme officielle en ligne qui propose des cours et des examens HSK et YCT. C'est une société à responsabilité limitée basée à Singapour, qui offre une solution technologique pour favoriser l'apprentissage des étudiants et autoriser les enseignants à fournir un soutien nécessaire tout au long de l'apprentissage individuel des étudiants.",
  about_us_cti_text: 'Pour en savoir plus :',
  about_us_wohui_text: 'Si vous souhaitez en savoir plus, veuillez contacter :',
  listening_section: 'Compréhension orale',
  reading_section: 'Section Lecture',
  writing_section: 'Section Expression écrite',
  review_answers: 'Vérifier les réponses',
  characters_long:
    "Si vous n'avez pas encore de compte, veuillez définir un mot de passe de 6 à 20 caractères.",
  complete_profile: 'Compléter le profil personnel',
  verify_email: 'Vérifiez votre e-mail',
  link_sent:
    'Merci de vous être inscrit(e). Veuillez cliquer sur le lien que nous vous avons envoyé par e-mail pour confirmer votre adresse e-mail :',
  resend_link: 'Renvoyer le lien',
  restart: 'Redémarrer',
  parental_consent: 'Consentement des parents',
  sent_parental:
    'Merci de vous être inscrit(e). Veuillez suivre les instructions que nous avons envoyées par e-mail pour obtenir le consentement de vos parents ou tuteurs :',
  thank_you: 'Merci !',
  or_return: 'Ou revenir au programme',
  child_profile: 'Profil personnel de votre enfant',
  sign_up_privacy:
    'J\'ai lu et j\'accepte les <a class="link" target="_blank" rel="noopener noreferrer" href="{url}">Conditions d\'utilisation</a> et la <a class="link" target="_blank" rel="noopener noreferrer" href="{userUrl}">Politique de confidentialité</a>.',
  give_consent: "J'accepte",
  delete_child_details: "Supprimer les informations de l'enfant",
  account_created: 'Créer un compte',
  emailed_know:
    "Nous avons envoyé un e-mail à <span style='font-weight: 700'>{email}</span> pour l'informer.",
  account_deleted: 'Supprimer le compte',
  child_know_deleted:
    'Veuillez informer votre enfant que leurs informations détaillées ont été supprimées.',
  request_email:
    "Les informations ci-dessus (à l'exception de l'adresse e-mail) peuvent être mises à jour après la connexion.Veuillez donner votre accord pour que votre enfant crée un compte, sinon veuillez nous demander de supprimer les informations détaillées.",
  preferred_currency: 'Devise préférée',
  parent_guardian: 'Parents/Tuteurs',
  class_name: 'Nom de la classe',
  tofficial_platform: 'La seule plateforme officielle HSK',
  tofficial_platform_new: 'Plateforme officielle d’examen blanc HSK',
  proficiency_tests: 'Pour préparer le test de chinois le plus populaire dans le monde',
  proficiency_tests_new: 'Combine des épreuves authentiques, une évaluation professionnelle, un renforcement du vocabulaire et des exercices intelligents pour une préparation efficace.',
  get_started: 'Commencez!',
  get_started_new: 'Commencer',
  start_practicing: 'Commencer la pratique',
  get_ready: 'Préparez-vous au HSK dès maintenant !',
  real_hsk_exam_content: 'Épreuves authentiques',
  real_hsk_exam_desc: 'Entraînez-vous avec de vraies épreuves officielles pour une préparation efficace et confiante.',
  official_level_scoring: 'Évaluation professionnelle',
  official_level_scoring_desc: 'Notation conforme aux standards officiels du HSK, résultats fiables et reconnus.',
  vocabulary_boost: 'Renforcement du vocabulaire',
  vocabulary_boost_desc: 'Utilisez nos cartes de vocabulaire gratuites et outils intelligents pour mémoriser chaque mot facilement !',
  get_hsk_ready: 'Commencer la préparation',
  how_it_works: 'Comment utiliser',
  choose_your_level: 'Choisissez votre niveau',
  choose_your_level_desc: 'Sélectionnez le niveau qui vous correspond — du HSK Niveau 1 au Niveau 9.',
  practise_and_learn: 'Apprentissage et évaluation',
  practise_and_learn_desc: 'Commencez par l’entraînement gratuit du vocabulaire ! Passez à un compte premium pour débloquer les examens blancs officiels HSK et le service d’évaluation intelligente.',
  track_your_progress: 'Suivi de la progression',
  track_your_progress_desc: ' Consultez vos scores après chaque test, suivez vos progrès et planifiez votre préparation efficacement.',

  got_questions: 'Des questions ? Nous avons les réponses',
  faq: 'FAQ',
  faq_desc: 'Questions fréquentes sur la préparation HSK et la plateforme HSK Mock.',
  faq_btn: 'Voir la FAQ',

  blog: 'Blog',
  blog_desc: 'Découvrez nos conseils pour réussir votre préparation au HSK.',
  blog_btn: 'Consulter le blog',

  contact: 'Contactez-nous',
  contact_desc: 'Besoin d’aide personnalisée ? Notre équipe est à votre disposition.',
  contact_btn: 'Contactez-nous',

  mock_tests: 'Examen blanc',
  blog_and_faq: 'FAQ et Blog',
  real_results_from_real_learners: 'Des retours réels, des résultats concrets',
  support: 'Aide et support',
  choose_your_hsk_level: 'Choisissez votre niveau HSK',
  choose_your_hsk_level_desc: 'Préparez le HSK, le HSK Oral et le YCT grâce aux examens blancs officiels et outils intelligents.',

  hsk_levels: 'HSK',
  hsk_speaking: 'HSK Oral',
  yct: 'YCT',
  // hsk3.0
  hsk_levels_tri: 'New HSK',

  start_learning: 'Commencez votre apprentissage dès maintenant',
  for_institutions: 'Écoles et institutions éducatives',

  // for_hsk3_condidates: '适用于HSK 3考生',
  // for_hsk4_condidates: '适用于HSK 4考生',
  // for_hsk56_condidates: '适用于HSK 5-6考生',



  platform_china: 'Cette plateforme offre aussi son service aux candidats basés en Chine',
  take_confidence: "Réussir l'examen HSK est à portée de main",
  practice_tests: 'Pratiquez les tests HSK et YCT',
  using_time:
    "En utilisant les sujets récents du HSK fournis par le comité d'examen, vous serez entraîné(e) au format du test HSK, à répondre aux différents types de questions, et à compléter chaque section dans le temps imparti.",
  instant_results: 'Retour immédiat sur les résultats',
  each_test_question:
    'Révisez chaque question dans le test. Vos tests ne sont pas seulement notés pour vous, mais vous pouvez également vérifier à quelles questions vous avez correctement répondu. Pour les réponses fausses, vous pouvez également voir la réponse correcte, afin de comprendre les sujets que devez spécifiquement travailler.',
  track_progress: 'Suivez les progrès que vous faites',
  ready_next_test:
    "Cela vous permettra de savoir exactement quand vous serez prêt(e) à passer l'examen et de maximiser vos chances de succès. L'historique vous donnera les dates et heures de chaque test d'entraînement que vous avez effectué, ainsi que l'évolution de vos résultats d'un test à l'autre.",
  receive_official_certificates: 'Obtenir un certificat officiel',
  certificates_provide_evidence:
    "Pour chaque test d'entraînement réussi, un certificat vous est délivré. Ces certificats attestent de votre niveau de compétences en chinois. Chaque certificat inclut un numéro d'identification unique et un code QR qui peut être scanné pour vérifier l'authenticité du certificat.",
  ready_next_level: 'Préparez-vous pour le prochain niveau HSK',
  check_description:
    "Veuillez lire les instructions du prochain niveau afin de comprendre les objectifs d'apprentissage. Familiarisez-vous avec le format de l'examen pour être bien préparé psychologiquement. Préparez-vous et révisez le vocabulaire requis afin de maîtriser les connaissances nécessaires pour l'examen",
  on_the_move: 'En cours ?',
  on_the_move_new: 'Téléchargez l’application HSK Mock pour étudier à tout moment,',
  download_mobile:
    "Après avoir téléchargé l'application mobile, vous pourrez effectuer des tests sur votre téléphone",
  download_mobile_new: 'où que vous soyez.',
  footer: 'HSK Mock est la plateforme officielle d’examens blancs HSK, regroupant épreuves authentiques, évaluation professionnelle, entraînement lexical et outils intelligents pour une préparation optimale.',
  hsk_beginner_advanced:
    "HSK est l'acronyme en pinyin de 'Hanyu Shuiping Kaoshi', ce qui signifie test de compétences en chinois. C'est le test de compétences en chinois le plus populaire au monde. Il comprend neuf niveaux, allant du niveau débutant au niveau avancé",
  more: 'Encore',
  more_menu: 'En savoir plus',
  ytc_beginner_advanced:
    "YCT est l'acronyme en anglais de 'Youth Chinese Test', ce qui signifie test de compétences en chinois pour les élèves des écoles primaire et secondaire. Il comprend quatre niveaux, allant du niveau débutant au niveau intermédiaire",
  coming_end: "La fin de l'année 2022 approche",
  candidates_proficiency_speaking: 'Ils testent la compétence des candidats en expression orale.',
  level_oral_tests:
    "HSKK est l'acronyme en pinyin de 'Hanyu Shuiping Kouyu Kaoshi', ce qui signifie test de compétences d'expression orale chinoise. C'est un test évaluant la capacité des candidats à parler en chinois",
  check_test_dates: "Confirmer la date d'examen",
  book_test: "Réserver l'examen",
  international_platform:
    'Notre plateforme pour la Chine est basée en Chine, notre plateforme internationale est basée à Singapour. Les deux plateformes fonctionnent de manière autonome. Veuillez choisir la plateforme la plus appropriée pour vous.',
  mock_platform: '官方模拟考试平台',
  home_proficiency_tests: '为最受欢迎的中文水平测试做准备',
  currency_type: 'Devise',
  Pick_your_level: 'Choisissez votre niveau',
  About_this_level: 'Présentation des niveaux',
  test_session: 'Session de test',
  Learning_resources: "Ressources d'apprentissage",
  Take_practice_test: "Exercice d'examen",
  Compare_syllabuses: 'Comparer les programmes',
  table_shows_syllabuses: 'Ce tableau montre les niveaux du HSK selon les différents programmes',
  forrgin_lang: '0547 est "Chinois en tant que langue étrangère"',
  Second_Language: '0523 est "Chinois en tant que langue vivante"',
  Requirement_entry: "Conditions d'inscription",
  most_Chinese_universities: 'La plupart des universités chinoises',
  Qing_Hua: 'Université de Qinghua',
  beijing_university: 'Université de Pékin',
  working_towards: "Participation à l'examen",
  On: 'Sur',
  Level_test: 'Test de niveau',
  Retake_level_test: "Repasser l'examen",
  practice_test: "Participer à un exercice d'examen",
  Compare_syllabuses_a: 'Comparaison des vocabulaires',
  Not_sure: 'Pas sûr de votre niveau ?',
  free_level_test: "Participez à l'auto-évaluation gratuite du niveau",
  Examples: 'Exemple de question',
  product_code: 'Code produit',
  enter_paper: 'Saisissez votre code pour participer au test',
  no_code: 'Pas de code ? Achetez-en un auprès de nos partenaires :',
  to_partner: 'Accédez au lien du partenaire',
  code_here: 'Veuillez saisir le code ici',
  start_assigment: 'Démarrer',
  view_assigment: 'Voir',
  continue_assigment: 'Continuer',
  choose_method: "Veuillez choisir un mode d'achat",
  choose_new_method: "Veuillez choisir un mode d'achat pour débloquer votre prochain test",
  browser_layer:
    "Veuillez utiliser le navigateur Google Chrome sur votre PC ou l'application sur votre appareil mobile.",
  partner_title1: 'Nous espérons que vous pourrez devenir',
  partner_title2: 'un partenaire local de HSK Mock',
  company_name: "Nom de l'entreprise",
  company_website: "Site web de l'entreprise",
  teachers_count: "Nombre d'enseignants HSK avec lesquels vous travaillez",
  learners_count: "Nombre d'élèves HSK avec lesquels vous travaillez",
  add_msg: 'Laissez-nous un message',
  contact_style: 'Comment pouvons-nous vous contacter ?',
  send: 'Soumettre',
  partner_forms_desc:
    'En tant que partenaire local de notre entreprise, vous deviendrez le contact principal des candidats, des enseignants, des écoles primaires / secondaires et universités de votre pays ou région. <br><br>Nos partenaires sont généralement des centres de formation et d\'examens HSK établis, qui souhaitent développer leur activité et accroître leur reconnaissance officielle. <br><br>Si vous souhaitez devenir notre partenaire local, veuillez <span style="color: #faae56; text-decoration-line: underline; cursor: pointer">d\'abord</span> vous connecter avec votre compte personnel sur HSK Mock, puis nous donner les informations de base ci-dessous. Nous vous contacterons ultérieurement.',
  submit_success: 'Soumis avec succès',
  help_students_for_testing: 'Aidez-vous des étudiants à préparer leurs examens ?',
  help_students_for_testing_desc:
    "Les enseignants jouent un rôle crucial pour aider les élèves à atteindre leurs prochains objectifs d'examen. Ils sont habilités à fournir un soutien d'apprentissage personnalisé aux étudiants.",
  become_partner: 'Devenez notre partenaire local',
  become_partner_desc:
    "Pour les candidats, il vaut mieux contacter le centre d'examen local dans leur langue maternelle pour se renseigner sur les détails de l'examen, et pouvoir choisir leur mode de paiement local préféré",
  partnership: 'Explorer la collaboration',
  students_forward: 'Aidez vos élèves',
  hsk_confidence: 'HSK en toute confiance',
  try_it_out: 'Essai gratuit',
  walk_through: "Familiarisez-vous avec le processus d'examen",
  teachers_page_desc1:
    "La plateforme est adaptée à l'enseignement en classe ainsi qu'à l'enseignement individuel, et permet aux élèves de se familiariser avec divers types de questions, de réviser le vocabulaire requis, de prévisualiser le contenu de l'examen et de maîtriser les techniques d'examen.",
  assign_practice_papers: 'Définir la date limite de soumission des réponses des élèves',
  teachers_page_desc2:
    "Publiez les questionnaires pour vos élèves. Vous pouvez utiliser les questionnaires de simulation comme des examens officiels pour aider les élèves à se familiariser avec les différents types de questions de l'examen HSK, afin qu'ils puissent répondre à toutes les sections dans le temps imparti",
  get_instant_results: 'Retour immédiat sur les résultats',
  teachers_page_desc3:
    "Pas besoin d'une correction manuelle par l'enseignant. Vérifiez si les élèves de la classe ont terminé les questionnaires assignés. Consultez les résultats de chaque questionnaire des élèves.",
  review_their_answers: 'Examiner les réponses des élèves',
  teachers_page_desc4:
    "Permettre une analyse approfondie des résultats des élèves, classe par classe, compétence par compétence, section par section et même question par question. En réexaminant les réponses des élèves, vous pouvez élaborer avec précision des plans d'enseignement personnalisés et fournir des commentaires ciblés.",
  track_prog: 'Suivi de la progression des élèves',
  teachers_page_desc5:
    "Les résultats de chaque examen des élèves et les réponses à chaque question du questionnaire montrent la progression et l'évolution des résultats lien avec chaque compétence. Ces enregistrements aident les enseignants à déterminer le meilleur moment pour que les élèves participent à l'examen réel afin d'obtenir les meilleurs résultats possibles.",
  students_next_level: 'Aider les élèves à aller plus loin',
  teachers_page_desc6:
    "Notre plateforme partenaire propose des cours officiels HSK et YCT, ainsi que les outils d'enseignement et les ressources dont vous avez besoin, pour permettre aux enseignants de fournir un soutien d'apprentissage personnalisé aux élèves.",
  teaching_resources: 'Ressources pédagogiques',
  for_teachers: 'Pour les enseignants',
  teachers_desc1:
    "Veuillez d'abord vous connecter avec votre compte personnel sur la plateforme de simulation d'examen HSK Mock.",
  teachers_desc2:
    'Veuillez remplir les informations de base ci-dessous, nous activerons un essai gratuit pour votre école.',
  school_name: "Nom de l'école",
  school_web: "Site web de l'école",
  num_of_hsk_teachers: "Nombre d'enseignants HSK",
  num_of_hsk_learners: "Nombre d'élèves HSK",
  hsk_submit_reading: 'lecture',
  pay_tip:
    "Si vous souhaitez utiliser Alipay ou WeChat pour payer les simulations d'examens, veuillez utiliser notre site en Chine : hskmock.cn",
  use_pc_or_app: 'Pour commencer, veuillez utiliser un ordinateur ou télécharger notre application',
  download_certificate: 'Télécharger le certificat',
  create_certificate: 'Générer le certificat',
  certificate_is_downloaded: 'Certificat téléchargé',
  pay_discount_title: 'Combien de sessions de test de niveau {level} souhaitez-vous acheter ?',
  total: 'Total',
  pay: 'Payer',
  price_desc:
    'La seule chose que vous devez payer, ce sont les sessions de test. Vous pouvez obtenir une réduction sur le prix des tests comme indiqué ci-dessous en achetant  plusieurs sessions de tests en une seule fois.',
  the_level: 'Niveau',
  discounted_price: 'Prix',
  price_contact_us:
    'Nous proposons également des options pour les écoles et autres organisations souhaitant regrouper les achats de plusieurs étudiants. Veuillez <span style="color: #faae56; text-decoration-line: underline; cursor: pointer">nous contacter</span> pour discuter de vos besoins spécifiques.',
  get_a_discount: 'Obtenir une réduction',
  finished_pay_discount_title:
    'Voici vos codes pour les tests de pratique au niveau {level_name} :',
  btn_goto_papers: 'Accédez aux épreuves de {level_name}',
  test_count: '{test_num} test | {test_num} tests',
  unit_price: '{price} / test',
  buy_code_tip:
    "Nous vous avons également envoyé ces codes par email.\nSélectionnez maintenant simplement l'épreuve {level_name} que vous souhaitez passer et entrez un code pour la déverrouiller.",
  discount_codes_left_tip:
    'Après ce test, il vous restera <span style="color: #62C1A5;font-size: 16px;font-weight: 500;">{count} codes</span> pour ce niveau.',
  manage_class: 'Gérer la classe',
  to_manage_class:
    "Le système de gestion de classe s'ouvrira dans un nouvel onglet. Lorsque vous aurez terminé, veuillez revenir à cet onglet et actualiser la page.",
  code_used: 'utilisé',
  code_can_be_used: 'peut être utilisé ',
  no_test: 'Quantité',
  history_purchase_quantity: 'Quantité',
  hsk_listen_part_title: 'Écoute : Partie {count}',
  hsk_read_part_title: 'Lecture : Partie {count}',
  hsk_write_part_title: 'Écriture : Partie {count}',
  Description: 'Présentation',
  Test_format: "Format de l'examen",
  Vocabulary: 'Vocabulaire',
  sso_login_signup: "Se connecter / S'enregistrer",
  sso_email_address: 'Adresse e-mail',
  sso_password: 'Mot de passe',
  sso_characters_long:
    "Si vous n'avez pas encore de compte, veuillez définir un mot de passe de 6 à 20 caractères.",
  sso_forget_pw: 'Mot de passe oublié',
  sso_continue: "Continuer l'examen",
  sso_no_binding_info_tip: 'Impossible de récupérer vos coordonnées',
  sso_third_login_tip: 'Veuillez sélectionner le site Web que vous souhaitez ouvrir',
  sso_third_login_wohui: 'Aller à Wo Hui Mandarin',
  sso_third_login_mock: 'Aller à HSK Mock',
  other_gender: 'Anonyme/Autre',
  hsk_enter_listening: 'Écoute',
  intro_msg_first: "Il y a {num} sections dans ce test, que vous devez compléter dans l'ordre.",
  intro_msg_second: 'Vous devez compléter chaque section dans le délai imparti.',
  intro_msg_third:
    'Vous pouvez passer à la section suivante avant la fin du délai, mais vous ne pourrez pas revenir aux sections précédentes.',
  dialogue_listening:
    "La première section du test est l'écoute. Appuyez sur play pour écouter l'extrait audio ci-dessous et ajustez les paramètres audio de votre appareil si nécessaire.",
  dialogue_listening_hskk:
    "Appuyez sur play pour écouter l'extrait audio ci-dessous et ajustez les paramètres audio de votre appareil si nécessaire.",
  dialogue_intro_msg_first:
    "Il y a une introduction générale, qui commence avec de la musique. Pendant que cette introduction est en cours de lecture, vous pouvez prévisualiser les questions pour la section d'écoute.",
  dialogue_intro_msg_first_hskk:
    "Lorsque la musique est diffusée, une introduction générale à l'examen est présentée.",
  dialogue_intro_msg_second:
    "Pour simuler le vrai test, vous ne pouvez pas mettre en pause, rejouer ou avancer rapidement l'audio dans la section d'écoute.",
  dialogue_intro_msg_second_hskk:
    "Pour simuler un examen réel, vous ne pouvez pas mettre en pause, répéter ou avancer rapidement.",
  dialogue_intro_msg_third:
    "À la fin de l'audio de la section d'écoute, vous aurez {duration} minutes pour revoir vos réponses.",
  dialogue_intro_question: 'Des questions ? ',
  dialogue_preload_intro_first:
    "Le fichier audio pour la section d'écoute est en train de se télécharger.",
  dialogue_preload_intro_second:
    "Une fois le téléchargement terminé, l'audio commencera à jouer automatiquement pour démarrer le test.",
  dialogue_preload_intro_third: 'Bonne chance !',
  dialogue_preload_title: 'Téléchargement des ressources pour le test',
  mock_paper_preview: 'Prévisualisez le papier test',
  dialogue_mock_paper_intro_title: 'Instructions',
  dialogue_mock_paper_intro_sentence1:
    "Ce test prend environ {minutes} minutes. Assurez-vous d'avoir suffisamment de temps et de batterie pour terminer le test d'une seule traite.",
  dialogue_mock_paper_intro_sentence2:
    "Le test est effectué en ligne, alors assurez-vous d'avoir une connexion internet stable.",
  dialogue_mock_paper_intro_sentence3:
    'Si vous utilisez un ordinateur de bureau/portable, veuillez utiliser un navigateur Web Chrome ou Safari à jour.',
  dialogue_mock_paper_intro_sentence4:
    'Si vous utilisez une tablette, veuillez utiliser notre application mobile plutôt que le navigateur Web.',
  dialogue_mock_paper_intro_sentence5:
    "Veuillez ne pas ouvrir d'autres fenêtres de navigateur ou d'applications mobiles, changer de langue ou brancher/débrancher d'autres appareils pendant le test.",
  diologue_mock_paper_quit: 'Quitter',
  dialogue_mock_paper_intro_button: "J'ai lu et compris",
  vocab_type: 'Partie du discours',
  deadline_passed: 'Date limite dépassée',
  mock_skip_introduction: "Passer l'introduction ?",
  sso_agree_policy:
    'Je suis d\'accord avec les <u class="strong"><a href="{url}" target="_blank">Conditions d\'utilisation</a></u> et la <u class="strong"><a href="{url}" target="_blank">Politique de confidentialité</a></u>.',
  sso_please_check:
    "Veuillez lire et accepter les Conditions d'utilisation et la Politique de confidentialité",
  sso_invalid_email_address: "Format d'email non valide",
  sso_invalid_password: 'Format de mot de passe incorrect',
  sso_loading: 'Chargement',
  sso_mock_platform: "La plateforme officielle de simulation d'examen",
  sso_home_proficiency_tests:
    'pour les tests de compétence en langue chinoise les plus populaires au monde.',
  sso_guardian_consent_error: 'Échec du consentement',
  sso_forget_pw_success: 'Email de réinitialisation de mot de passe envoyé avec succès',
  sso_forget_pw_error: "Échec de l'envoi de l'email de réinitialisation du mot de passe",
  sso_log_in_error: 'Échec de la connexion',
  sso_download_app_mobile:
    "Pour utiliser HSK Mock, veuillez visiter hskmock.com sur un ordinateur de bureau ou télécharger l'application mobile",
  Listening: 'Écoute',
  Reading: 'Lecture',
  Writing: 'Écriture',
  personal_info_display_name_as: 'Afficher le nom comme',
  code_pratice_text: 'Passer un mock test de  <span style="font-weight: 600;color: #0C0C0C"> {level_name} </span>  en utilisant <span style="font-weight: 600;color: #0C0C0C"> {paper_name} </span>.',
  code_input_text: 'Soit tapez un code :',
  use_code_limit: "Chaque Code ne peut être utilisé qu'une seule fois",
  code_select_text: 'Soit sélectionnez un code :',
  pay_discounts_desc1: "Pratiquer avec des sujets d'examens précédents vous aidera",
  pay_discounts_desc2:
    'à obtenir les meilleurs résultats possibles à votre examen [{type}] [{level}].',
  pay_discounts_desc3: 'Achetez-en un, obtenez-en un gratuitement',
  pay_discounts_desc4: `Si vous êtes déjà inscrit à un vrai examen [{type} {level}], vous pouvez bénéficier d'une offre "Achetez-en un, obtenez-en un gratuitement" sur les tests pratiques [{type} {level}] !`,
  pay_discounts_desc5: 'Combien de tests pratiques souhaitez-vous acheter ?',
  level_HSKK_text1: 'Le Test de Parole HSK évalue les capacités orales en chinois des candidats. Il se compose de trois niveaux : Débutant, Intermédiaire et Avancé.',
  level_HSKK_text2: "Le test de parole HSK se déroule sous forme d'enregistrement audio.",
  level_HSKK_text3: 'Les candidats au HSK3 doivent passer un test HSKK Débutant; les candidats au HSK4 un test Intermédiaire; et les candidats au HSK5 ou 6 un test Avancé.',
  test_download_desc: "Des papiers d'entraînement sont en cours de préparation pour ce niveau. En attendant, veuillez télécharger: ",
  speaking: 'Parler',
  Traduction: 'Traduire',
  my_homework_none_homework: 'L’attribution de tests à ce niveau n’est actuellement pas prise en charge.',
  my_class_none_test: 'L’expérience du test blanc en ligne n’est actuellement pas disponible pour ce niveau.',
  hsk_audio_error: 'Votre connexion Internet est instable, et l’audio n’a pas pu se charger. Veuillez réessayer.',
  mock_join_campus_text1: 'Acceptez-vous l’invitation à rejoindre cette communauté d’enseignement, d’apprentissage et de test de la langue chinoise?',
  mock_join_campus_text2: 'Rejoindre la communauté permettra aux enseignants de vous attribuer des épreuves de test sur HSKMock.com et/ou des exercices sur app.wohuimandarin.com.',
  sso_join_campus_text4: 'Cela permettra également à ces enseignants de consulter vos réponses afin de vous fournir des retours ciblés.',
  join: 'Rejoindre',
  free_practice_title: 'Pratique gratuite',
  choose_free_practice: 'Choisissez une méthode de pratique',
  word_flashcards: 'Cartes de vocabulaire',
  word_practice: 'Pratique de vocabulaire',
  analyse_text: 'Analyser un texte',
  flashcards_title: 'Cartes',
  practice_exercises_title: 'Exercices de pratique',
  analyse_title: 'Analyser',
  practice_result_title: 'Résultat de la pratique',
  generate_flashcards: 'Générer un ensemble de cartes',
  generate_practice: 'Générer un ensemble de questions de pratique',
  random_select: 'Sélection automatique',
  manual_select: 'Sélection manuelle',
  max_words: 'Maximum {number} mots',
  already_choose: 'Sélectionné: {total} ',
  free_practice_words_quantifier: '',
  // 产品确认错误提示
  free_practice_unchoose_question: 'Veuillez sélectionner un seul type de question',
  free_practice_unchoose_practice: 'Veuillez sélectionner un type de question de pratique',
  none_mark_words_hint: 'Mots non marqués',
  excceed_max_count: 'Maximum ({total}) mots dépassé',
  free_practice_sound: 'Son',
  free_practice_question: 'Question',
  free_practice_choose_exercise: "Choisissez le style d'exercice",
  free_practice_exercise_select: 'Sélectionner 1',
  free_practice_exercise_Pairs: 'Paires',
  free_practice_exercise_TF: 'Sélectionner V/F',
  launch: 'Lancer',
  free_practice_check_text: 'Avez-vous bien répondu?',
  free_practice_timer_pause: 'MINUTEUR EN PAUSE',
  free_practice_timer_pause_desc: "Le minuteur est automatiquement mis en pause si aucune activité n'est détectée pendant",
  free_practice_seconds: '{number} secondes',
  resume: 'REPRENDRE',
  flashcard_completed: 'Cartes terminées',
  practice_completed: 'Pratique terminée',
  practice_spent_minutes: 'Temps passé: {duration} minutes',
  practice_result_summary: 'Résumé des résultats',
  practice_result_progress_txt: 'Vous avez obtenu',
  practice_wrong: 'Faux',
  practice_skip: 'Sauté',
  practice_done: 'Terminé',
  analyse_desc_1: 'Analyser un texte pour le vocabulaire sélectionné',
  analyse_desc_2: 'Collez ou tapez un texte en caractères chinois (max. {maxCount} caractères)',
  analyse_input_placeholder: 'Entrez un texte en caractères chinois',
  free_practice_need_word: 'Sélectionnez le vocabulaire dans le tableau ou choisissez la sélection automatique',
  free_practice_exercise_select_title: 'Sélectionnez la bonne réponse',
  free_practice_exercise_pairs_title: 'Cliquez pour connecter les paires correspondantes',
  free_practice_exercise_meaning_title: 'doit être traduit comme',
  free_practice_exercise_sound_title: 'doit être prononcé comme',
  free_practice_exercise_characters_title: 'doit être écrit comme',
  free_practice_show_correct_answers: 'montrer la bonne réponse',
  free_practice_show_my_answers: 'Montrer mes réponses',
  free_practice_check: 'Vérifier',
  free_practice_correct: 'Correct',
  free_practice_characters: 'Caractères',
     hsk_introduce_objective_questions: 'Questions objectives',
  hsk_introduce_subjective_questions: 'Questions subjectives',
  hsk_input_type_here: 'Tapez ici',
  hsk_translation_part_title: 'Traduction : Partie {count}',
  hsk_speaking_part_title: 'Expression orale : Partie {count}',
  subjective_reading_placeholder: "Veuillez répondre aux questions en fonction de l'article ci-dessus...",
  hsk_write_by_artical: 'Veuillez rédiger un essai en fonction du matériel ci-dessus...',
  hsk_translation_by_artical: 'Veuillez traduire en fonction du matériel ci-dessus...',
  hsk_trasnlation_choose_language: 'La prochaine section est celle de la traduction. Veuillez sélectionner votre langue.',
  choose_speaker: 'Sélectionnez un haut-parleur.',
  choose_microphone: 'Sélectionnez un microphone.',
  hsk_is_recording: 'Enregistrement en cours.',
  dialogue_speaking: "La dernière section est celle de l'expression orale. Veuillez vous assurer que les haut-parleurs et le microphone de votre appareil fonctionnent correctement.",
  start_recording: "Cliquez pour commencer l'enregistrement",
  hsk_write_count: 'Caractères',
  error_access_media: "Erreur d'accès aux périphériques multimédia.",
  setSinkId_not_supported: "{setSinkId} n'est pas pris en charge dans votre navigateur.",
  error_switch_device: 'Erreur lors du changement de périphérique.',
  translation_section: 'Section de traduction',
  speaking_section: "Section d'expression orale",
  failed_upload_record: "Le téléchargement de l'audio a échoué, veuillez cliquer pour télécharger à nouveau.",
  hsk_enter_next_segment_write_high: "Voulez-vous soumettre votre écriture ? Cela mettra fin à la section d'écriture, et vous ne pourrez plus revenir en arrière pour apporter d'autres modifications.",
  hsk_enter_next_segment_translate_tip: "{count} questions de traduction n'ont pas encore été répondues.",
  hsk_enter_next_segment_translate: "Voulez-vous soumettre vos traductions ? Cela mettra fin à la section de traduction, et vous ne pourrez plus revenir en arrière pour apporter d'autres modifications.",
  hsk_enter_next_segment_speaking_tip: "{count} questions d'expression orale n'ont pas encore été répondues.",
  Speaking: 'Parler',
  Translating: 'Traduire',

  back_to_home: 'Retour à l’accueil',
  about_us_desc:
    '<b>HSK Mock</b> est une plateforme officielle en ligne pour les examens <b>HSK</b>, <b>HSK Oral</b> et <b>YCT</b>. Elle reproduit fidèlement les conditions réelles d’examen pour aider les apprenants à se préparer avec confiance et à évaluer précisément leur niveau.',
  who_we_are: 'Qui sommes-nous',
  who_we_are_desc:
    'HSK Mock est développée conjointement par Chinese Testing International (CTI) et Wo Hui Mandarin, afin de fournir aux apprenants du monde entier des outils fiables et officiels de simulation et d’apprentissage du chinois.',
  why_choose_hsk_mock: 'Pourquoi choisir HSK Mock ?',
  about_us_carousel_1: 'Banque officielle d’examens',
  about_us_carousel_1_content:
    'HSK Mock respecte scrupuleusement la structure et les formats officiels du HSK, du HSK Oral et du YCT.',
  about_us_carousel_2: 'Système d’évaluation officiel',
  about_us_carousel_2_content:
    'HSK Mock applique les mêmes critères de notation que les examens réels pour une évaluation précise du niveau.',
  about_us_carousel_3: 'Outils d’apprentissage efficaces',
  about_us_carousel_3_content:
    'HSK Mock propose également des exercices de vocabulaire interactifs pour chaque niveau, améliorant les compétences d’écoute, d’expression, de lecture et d’écriture.',
  about_us_carousel_4: 'Utilisation flexible sur plusieurs appareils',
  about_us_carousel_4_content: 'HSK Mock est compatible sur ordinateur et mobile, pour pratiquer n’importe où et à tout moment.',
  about_us_carousel_5: 'Le choix des apprenants du monde entier',
  about_us_carousel_5_content: 'HSK Mock aide des étudiants du monde entier à atteindre leurs objectifs d’apprentissage du chinois.',
}
